
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/users?${queryString}`);
    return response.data;
  },

  async getById(id) {
    const response = await https.get(`/users/${id}`);
    return response.data.data;
  },

  async add(payload) {
    const response = await https.post(`/users`, payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await https.put(`/users/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/users/${id}`);
    return response.data;
  },
});
